module.exports = __webpack_public_path__ + "static/bg-phones-slide-c9343c1230bca520fdaa9c92d16473dd.svg";